export default Object.freeze({
  facebookMessage: {
    mainText: 'Stay tuned for Facebook marketing to:',
    bulletPoints: [
      '<b>Simplify:</b> Build Facebook/Instagram ad campaigns directly from within your LionDesk account.',
      '<b>Save time:</b> Launch high converting ads for listings, open houses and more in under 5 minutes.',
      '<b>Get results:</b> Ads optimized by Facebook Ad partner. Results delivered in a simplified dashboard.',
      '<b>Competitive advantage:</b> Access powerful buyer audiences available exclusively to LionDesk users.',
    ],
  },
  googleAdsMessage: {
    mainText: 'Stay tuned for Google Ads to:',
    bulletPoints: ['Create ads for Google users anywhere', 'Manage your ads'],
  },
  facebookBusinessAdAccountProperties: {
    title: 'Sync LionDesk Contacts to a Facebook Custom Audience',
    subTitle: '',
    headlineClass: 'primary--text',
    text:
      'Sync your contacts in LionDesk with custom audiences in Facebook.\n\nTarget your audience using your Facebook Business ad account.',
  },
  facebookMarketingPlatformProperties: {
    title: 'LionDesk Facebook Ad Portal',
    subTitle: '',
    headlineClass: 'primary--text',
    text:
      'Generate leads and website traffic using proven ad blueprints and custom audience lists. Easiest way to run Facebook Ads.',
  },
  boostMarketingPlatformProperties: {
    title: 'LionDesk Ad Portal',
    subTitle: '',
    headlineClass: 'primary--text',
    text:
      'The easiest way to run Facebook, Nextdoor, and web ads for yourself and your listings. Automatically capture leads with LionDesk Landing Pages or generate traffic to your website.',
  },
  googleAdsProperties: {
    title: 'Google Ads',
    subTitle: 'Coming soon!',
    headlineClass: 'green--text',
    text: 'Create and manage ads to be displayed to Google users anywhere.',
  },
  breakthroughBrokerProperties: {
    title: 'Direct Mail',
    headlineClass: 'primary--text',
    text:
      'Download free professionally designed brochures, postcards, letterheads and more offered by Breakthrough Broker. Customize with your info and photo for your needs.',
  },
  landingPages: {
    title: 'Landing Pages',
    headlineClass: 'primary--text',
    text:
      'Create beautiful, high converting landing pages directly connected to your LionDesk database.  This is the easiest and most cost-effective way to grow your database with massive amounts of leads. Combine with LionDesk’s Facebook Ads for increased efficiency and the greatest results.',
  },
  leadsPlusMarketingPlataformProperties: {
    title: 'Leads+',
    headlineClass: 'primary--text',
    text:
      "Get more leads and win more deals with done-for-you digital marketing. Boost and LionDesk CRM are coming together to create real estate's premier done-for-you solution for digital marketing plus seller lead generation and qualification.",
  },
});
